import * as types from "../types/playlistTemplates";

const initialState = {
  isPartialLoading: false,
  isLoading: false,
  isError: null,
  data: {},
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.IS_LOADING:
      return { ...state, isLoading: payload };
    case types.IS_PARTIAL_LOADING:
      return { ...state, isPartialLoading: payload };
    case types.IS_ERROR:
      return { ...state, isError: payload };
    case types.DATA:
      return { ...state, data: payload };
    default:
      return state;
  }
}
